import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import { StyledExportProgress } from './export-progress.styled';

// Enough of the ring to read as motion while it spins.
const indeterminateArc = 25;

/**
 * The backend only reports progress while it writes the file, which takes about
 * a second — the rest of the wait is the scheduler picking the job up. Left as a
 * plain progress ring it would therefore sit at zero for the whole wait and read
 * as frozen, so until a real number arrives the ring spins instead.
 */
export const ExportProgress = ({ progress }: { progress: number }) => {
	const indeterminate = progress <= 0;

	return (
		<StyledExportProgress $indeterminate={indeterminate}>
			<CircularProgressbar
				value={indeterminate ? indeterminateArc : progress}
				maxValue={100}
				styles={buildStyles({
					pathColor: '#0B93E3',
					trailColor: '#DAE4E8',
				})}
			/>
		</StyledExportProgress>
	);
};
